import { useState, useEffect } from "react";
import adminApi from "../api/adminAxios";

const inr = n => new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n);

const STATUS_CONFIG = {
  pending:    { color: "#c47a3a", bg: "#fff4ec", icon: "🕐" },
  processing: { color: "#c4a020", bg: "#fffbec", icon: "⚙️" },
  shipped:    { color: "#3a6ab0", bg: "#eef4ff", icon: "🚚" },
  delivered:  { color: "#3a8a68", bg: "#eefaf4", icon: "✅" },
  cancelled:  { color: "#c0392b", bg: "#fff0f0", icon: "❌" },
};
const ALL_STATUSES = ["pending", "processing", "shipped", "delivered", "cancelled"];

const fmt = (ts) => {
  const d = new Date(ts);
  return d.toLocaleString("en-IN", {
    day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit", hour12: true,
  });
};

// ── PDF Bill Generator ──────────────────────────────────────────────────────
function printBill(order, history) {
  const statusRows = history.map(h => {
    const cfg = STATUS_CONFIG[h.status] || { icon: "•" };
    return `<tr>
      <td style="padding:10px 16px;border-bottom:1px solid #f0ebe3;">
        <span style="font-size:16px;margin-right:8px;">${cfg.icon}</span>
        <strong style="text-transform:capitalize;">${h.status}</strong>
      </td>
      <td style="padding:10px 16px;border-bottom:1px solid #f0ebe3;color:#888;">${fmt(h.timestamp)}</td>
      <td style="padding:10px 16px;border-bottom:1px solid #f0ebe3;color:#888;font-style:italic;">${h.note || "—"}</td>
    </tr>`;
  }).join("");

  const itemRows = order.items?.map(i =>
    `<tr>
      <td style="padding:8px 16px;border-bottom:1px solid #f0ebe3;">${i.product_name}</td>
      <td style="padding:8px 16px;border-bottom:1px solid #f0ebe3;text-align:center;">×${i.quantity}</td>
      <td style="padding:8px 16px;border-bottom:1px solid #f0ebe3;text-align:right;">${inr(parseFloat(i.price) * i.quantity)}</td>
    </tr>`
  ).join("") || "";

  const html = `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8"/>
  <title>Order Bill #${order.id}</title>
  <style>
    * { margin:0; padding:0; box-sizing:border-box; font-family: Georgia, serif; }
    body { background:#fff; color:#1a1a1a; padding:40px; }
    .header { border-bottom:3px solid #e07b39; padding-bottom:20px; margin-bottom:28px; display:flex; justify-content:space-between; align-items:flex-end; }
    .brand { font-size:22px; font-weight:700; color:#1a1a1a; letter-spacing:.12em; }
    .brand span { color:#e07b39; }
    .invoice-id { font-size:13px; color:#888; }
    h3 { font-size:11px; text-transform:uppercase; letter-spacing:.12em; color:#aaa; margin:20px 0 10px; }
    table { width:100%; border-collapse:collapse; font-size:13px; }
    th { background:#f7f2eb; padding:10px 16px; text-align:left; font-size:10px; text-transform:uppercase; letter-spacing:.08em; color:#aaa; }
    .total-row { background:#fff8f0; font-weight:700; }
    .total-row td { padding:12px 16px; border-top:2px solid #e07b39; color:#e07b39; font-size:15px; }
    .status-badge { display:inline-block; padding:3px 12px; border-radius:999px; font-size:11px; font-weight:700; text-transform:capitalize; }
    .footer { margin-top:40px; border-top:1px solid #f0ebe3; padding-top:16px; font-size:11px; color:#aaa; text-align:center; }
    @media print { body { padding:20px; } }
  </style>
</head>
<body>
  <div class="header">
    <div>
      <div class="brand">🕯️ <span>SJ</span> AROMA CANDLES</div>
      <div style="font-size:12px;color:#888;margin-top:4px;">Mumbai, Maharashtra · sjaromacandles@gmail.com</div>
    </div>
    <div style="text-align:right;">
      <div style="font-size:20px;font-weight:700;">ORDER BILL</div>
      <div class="invoice-id">Order #${order.id} · ${fmt(order.created_at)}</div>
    </div>
  </div>

  <div style="display:grid;grid-template-columns:1fr 1fr;gap:24px;margin-bottom:28px;">
    <div>
      <h3>Customer Details</h3>
      <p><strong>${order.user}</strong></p>
      <p style="color:#666;font-size:13px;">${order.user_email}</p>
      ${order.phone ? `<p style="color:#666;font-size:13px;">📞 ${order.phone}</p>` : ""}
    </div>
    <div>
      <h3>Order Info</h3>
      <p style="font-size:13px;color:#666;">Payment: <strong>${order.payment_method?.toUpperCase() || "COD"}</strong></p>
      <p style="font-size:13px;color:#666;margin-top:4px;">Shipping: ${order.shipping_address || "—"}</p>
    </div>
  </div>

  <h3>Items Ordered</h3>
  <table style="margin-bottom:0;">
    <thead><tr><th>Product</th><th style="text-align:center;">Qty</th><th style="text-align:right;">Amount</th></tr></thead>
    <tbody>
      ${itemRows}
      <tr class="total-row">
        <td colspan="2">Total</td>
        <td style="text-align:right;">${inr(order.total_price)}</td>
      </tr>
    </tbody>
  </table>

  <h3 style="margin-top:32px;">Status Timeline</h3>
  <table>
    <thead><tr><th>Status</th><th>Date & Time</th><th>Note</th></tr></thead>
    <tbody>${statusRows || '<tr><td colspan="3" style="padding:12px 16px;color:#aaa;">No history recorded yet.</td></tr>'}</tbody>
  </table>

  <div class="footer">
    Thank you for shopping with SJ Aroma Candles ·
    For queries: sjaromacandles@gmail.com · +91 70219 16502
  </div>
</body>
</html>`;

  const win = window.open("", "_blank");
  win.document.write(html);
  win.document.close();
  win.focus();
  setTimeout(() => { win.print(); }, 500);
}

// ── Component ───────────────────────────────────────────────────────────────
export default function ManageOrders() {
  const [orders, setOrders]             = useState([]);
  const [loading, setLoading]           = useState(true);
  const [search, setSearch]             = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [updatingId, setUpdatingId]     = useState(null);
  // History / Bill modal
  const [historyModal, setHistoryModal] = useState(null); // { order, entries }
  const [historyLoading, setHistoryLoading] = useState(false);

  useEffect(() => {
    adminApi.get("admin/orders/")
      .then(r => setOrders(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const filtered = orders.filter(o => {
    const matchSearch = !search ||
      [String(o.id), o.user, o.user_email].some(v => v?.toLowerCase().includes(search.toLowerCase()));
    const matchStatus = statusFilter === "all" || o.status === statusFilter;
    return matchSearch && matchStatus;
  });

  const handleStatusChange = async (orderId, newStatus) => {
    setUpdatingId(orderId);
    try {
      await adminApi.patch(`admin/orders/${orderId}/status/`, { status: newStatus });
      setOrders(prev => prev.map(o => o.id === orderId ? { ...o, status: newStatus } : o));
      if (selectedOrder?.id === orderId) setSelectedOrder(prev => ({ ...prev, status: newStatus }));
    } catch {}
    finally { setUpdatingId(null); }
  };

  const openHistory = async (order) => {
    setHistoryLoading(true);
    setHistoryModal({ order, entries: [] });
    try {
      const res = await adminApi.get(`admin/history/order/${order.id}/`);
      setHistoryModal({ order, entries: res.data });
    } catch {
      setHistoryModal({ order, entries: [] });
    } finally {
      setHistoryLoading(false);
    }
  };

  const stats = {
    pending: orders.filter(o => o.status === "pending").length,
    shipped: orders.filter(o => o.status === "shipped").length,
    delivered: orders.filter(o => o.status === "delivered").length,
  };

  return (
    <div style={{ padding: "32px 36px", fontFamily: "Georgia, serif" }}>
      {/* Header */}
      <div style={{ marginBottom: "28px" }}>
        <h1 style={{ fontSize: "24px", fontWeight: "700", color: "#1a1a1a" }}>Manage Orders</h1>
        <p style={{ fontSize: "13px", color: "#aaa", marginTop: "4px" }}>Monitor and manage all customer purchases and shipments.</p>
      </div>

      {/* Stats */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: "14px", marginBottom: "24px" }}>
        {[
          { label: "Pending Orders", value: stats.pending,   color: "#c47a3a", bg: "#fff4ec", icon: "⏳" },
          { label: "In Transit",     value: stats.shipped,   color: "#3a6ab0", bg: "#eef4ff", icon: "🚚" },
          { label: "Completed",      value: stats.delivered, color: "#3a8a68", bg: "#eefaf4", icon: "✅" },
        ].map(({ label, value, color, bg, icon }) => (
          <div key={label} style={{ background: bg, borderRadius: "12px", padding: "16px 20px",
            display: "flex", alignItems: "center", gap: "14px" }}>
            <span style={{ fontSize: "24px" }}>{icon}</span>
            <div>
              <p style={{ fontSize: "22px", fontWeight: "700", color }}>{value}</p>
              <p style={{ fontSize: "11px", color: "#888" }}>{label}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Filters */}
      <div style={{ background: "#fff", borderRadius: "14px", padding: "16px 20px",
        border: "1px solid #f0ebe3", marginBottom: "16px",
        display: "flex", gap: "12px", alignItems: "center", flexWrap: "wrap" }}>
        <div style={{ position: "relative", flex: 1, minWidth: "200px" }}>
          <span style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: "#bbb" }}>🔍</span>
          <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search orders..."
            style={{ width: "100%", padding: "8px 12px 8px 34px", borderRadius: "9px",
              border: "1.5px solid #e8d5b8", background: "#fffaf4",
              fontFamily: "Georgia, serif", fontSize: "12px", outline: "none", boxSizing: "border-box" }} />
        </div>
        <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
          {["all", ...ALL_STATUSES].map(s => (
            <button key={s} onClick={() => setStatusFilter(s)}
              style={{ padding: "6px 14px", borderRadius: "999px", border: "none",
                cursor: "pointer", fontFamily: "Georgia, serif", fontSize: "11px",
                fontWeight: statusFilter === s ? "700" : "400",
                background: statusFilter === s ? "#e07b39" : "#f0ebe3",
                color: statusFilter === s ? "#fff" : "#888", textTransform: "capitalize" }}>
              {s === "all" ? "All Orders" : s}
            </button>
          ))}
        </div>
      </div>

      {/* Table */}
      <div style={{ background: "#fff", borderRadius: "14px", border: "1px solid #f0ebe3", overflow: "hidden" }}>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse",
            fontFamily: "Georgia, serif", minWidth: "1000px" }}>
            <thead>
              <tr style={{ background: "#f7f2eb" }}>
                {["ORDER ID","CUSTOMER","DATE","TOTAL","PAYMENT","STATUS","BILL","ACTION"].map(h => (
                  <th key={h} style={{ padding: "11px 14px", textAlign: "left",
                    fontSize: "9px", fontWeight: "700", color: "#aaa",
                    letterSpacing: "0.08em", whiteSpace: "nowrap",
                    fontFamily: "Georgia, serif", borderBottom: "1px solid #f0ebe3" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={8} style={{ padding: "40px", color: "#aaa", textAlign: "center", fontSize: "13px" }}>Loading orders...</td></tr>
              ) : filtered.length === 0 ? (
                <tr><td colSpan={8} style={{ padding: "40px", color: "#aaa", textAlign: "center", fontSize: "13px" }}>No orders found.</td></tr>
              ) : (
                filtered.map(order => {
                  const cfg = STATUS_CONFIG[order.status] || { color: "#888", bg: "#f5f5f5", icon: "•" };
                  return (
                    <tr key={order.id} style={{ borderBottom: "1px solid #f7f2eb" }}
                      onMouseEnter={e => e.currentTarget.style.background = "#fffaf4"}
                      onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                      <td style={{ padding: "13px 14px", fontSize: "12px", fontWeight: "700", color: "#e07b39" }}>#{order.id}</td>
                      <td style={{ padding: "13px 14px", minWidth: "140px" }}>
                        <p style={{ fontSize: "12px", fontWeight: "600", color: "#1a1a1a" }}>{order.user}</p>
                        <p style={{ fontSize: "10px", color: "#aaa" }}>{order.user_email}</p>
                      </td>
                      <td style={{ padding: "13px 14px", fontSize: "11px", color: "#888", whiteSpace: "nowrap" }}>
                        {new Date(order.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}
                      </td>
                      <td style={{ padding: "13px 14px", fontSize: "12px", fontWeight: "700", color: "#1a1a1a", whiteSpace: "nowrap" }}>
                        {inr(order.total_price)}
                      </td>
                      <td style={{ padding: "13px 14px", fontSize: "11px", color: "#555", textTransform: "uppercase" }}>
                        {order.payment_method || "—"}
                      </td>
                      <td style={{ padding: "13px 14px" }}>
                        <select value={order.status} disabled={updatingId === order.id}
                          onChange={e => handleStatusChange(order.id, e.target.value)}
                          style={{ padding: "5px 8px", borderRadius: "8px",
                            border: `1.5px solid ${cfg.color}`, background: cfg.bg,
                            color: cfg.color, fontFamily: "Georgia, serif",
                            fontSize: "11px", fontWeight: "700", cursor: "pointer", outline: "none" }}>
                          {ALL_STATUSES.map(s => (
                            <option key={s} value={s} style={{ background: "#fff", color: "#1a1a1a" }}>
                              {s.charAt(0).toUpperCase() + s.slice(1)}
                            </option>
                          ))}
                        </select>
                      </td>
                      {/* Bill / History */}
                      <td style={{ padding: "13px 14px" }}>
                        <button onClick={() => openHistory(order)}
                          title="View status timeline & print bill"
                          style={{ padding: "5px 10px", borderRadius: "7px",
                            background: "#eef4ff", border: "1.5px solid #c8d8f0",
                            cursor: "pointer", fontFamily: "Georgia, serif",
                            fontSize: "11px", fontWeight: "600", color: "#3a6ab0",
                            whiteSpace: "nowrap" }}>
                          📄 Bill
                        </button>
                      </td>
                      <td style={{ padding: "13px 14px" }}>
                        <button onClick={() => setSelectedOrder(order)}
                          style={{ padding: "6px 12px", borderRadius: "8px",
                            background: "#f0ebe3", border: "none", cursor: "pointer",
                            fontFamily: "Georgia, serif", fontSize: "11px",
                            fontWeight: "600", color: "#555" }}>
                          View
                        </button>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
        {!loading && (
          <div style={{ padding: "12px 20px", background: "#faf7f2" }}>
            <span style={{ fontFamily: "Georgia, serif", fontSize: "11px", color: "#aaa" }}>
              Showing {filtered.length} of {orders.length} orders
            </span>
          </div>
        )}
      </div>

      {/* Order detail modal */}
      {selectedOrder && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.45)", zIndex: 1000,
          display: "flex", alignItems: "center", justifyContent: "center", padding: "24px" }}
          onClick={e => { if (e.target === e.currentTarget) setSelectedOrder(null); }}>
          <div style={{ background: "#fff", borderRadius: "18px", padding: "28px",
            maxWidth: "520px", width: "100%", boxShadow: "0 16px 60px rgba(0,0,0,.15)",
            maxHeight: "85vh", overflowY: "auto" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
              <h3 style={{ fontFamily: "Georgia, serif", fontSize: "16px", fontWeight: "700", color: "#1a1a1a" }}>
                Order #{selectedOrder.id}
              </h3>
              <button onClick={() => setSelectedOrder(null)}
                style={{ background: "none", border: "none", cursor: "pointer", fontSize: "18px", color: "#aaa" }}>✕</button>
            </div>
            <div style={{ background: "#faf7f2", borderRadius: "12px", padding: "16px", marginBottom: "18px" }}>
              <p style={{ fontFamily: "Georgia, serif", fontSize: "10px", color: "#aaa", textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: "8px" }}>Change Status</p>
              <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                {ALL_STATUSES.map(s => {
                  const cfg = STATUS_CONFIG[s];
                  return (
                    <button key={s} onClick={() => handleStatusChange(selectedOrder.id, s)}
                      style={{ padding: "6px 14px", borderRadius: "999px",
                        border: `1.5px solid ${selectedOrder.status === s ? cfg.color : "#e8d5b8"}`,
                        background: selectedOrder.status === s ? cfg.bg : "#fff",
                        color: selectedOrder.status === s ? cfg.color : "#888",
                        cursor: "pointer", fontFamily: "Georgia, serif", fontSize: "11px",
                        fontWeight: selectedOrder.status === s ? "700" : "400", textTransform: "capitalize" }}>
                      {s}
                    </button>
                  );
                })}
              </div>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginBottom: "18px" }}>
              {[
                { label: "Customer",  value: selectedOrder.user },
                { label: "Email",     value: selectedOrder.user_email },
                { label: "Phone",     value: selectedOrder.phone || "—" },
                { label: "Payment",   value: selectedOrder.payment_method?.toUpperCase() || "—" },
                { label: "Total",     value: inr(selectedOrder.total_price) },
                { label: "Date",      value: new Date(selectedOrder.created_at).toLocaleDateString("en-IN") },
              ].map(({ label, value }) => (
                <div key={label} style={{ background: "#faf7f2", borderRadius: "10px", padding: "10px 12px" }}>
                  <p style={{ fontFamily: "Georgia, serif", fontSize: "9px", color: "#aaa", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: "3px" }}>{label}</p>
                  <p style={{ fontFamily: "Georgia, serif", fontSize: "12px", fontWeight: "600", color: "#1a1a1a", wordBreak: "break-all" }}>{value}</p>
                </div>
              ))}
            </div>
            {selectedOrder.shipping_address && (
              <div style={{ background: "#faf7f2", borderRadius: "10px", padding: "10px 12px", marginBottom: "18px" }}>
                <p style={{ fontFamily: "Georgia, serif", fontSize: "9px", color: "#aaa", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: "3px" }}>Shipping Address</p>
                <p style={{ fontFamily: "Georgia, serif", fontSize: "12px", color: "#555" }}>{selectedOrder.shipping_address}</p>
              </div>
            )}
            <p style={{ fontFamily: "Georgia, serif", fontSize: "11px", fontWeight: "700", color: "#1a1a1a", marginBottom: "10px" }}>Order Items</p>
            {selectedOrder.items?.map((item, i) => (
              <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: "1px solid #f0ebe3" }}>
                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                  <span style={{ fontSize: "18px" }}>🕯️</span>
                  <div>
                    <p style={{ fontFamily: "Georgia, serif", fontSize: "12px", fontWeight: "600", color: "#1a1a1a" }}>{item.product_name}</p>
                    <p style={{ fontFamily: "Georgia, serif", fontSize: "10px", color: "#aaa" }}>Qty: {item.quantity}</p>
                  </div>
                </div>
                <p style={{ fontFamily: "Georgia, serif", fontSize: "12px", fontWeight: "700", color: "#e07b39" }}>{inr(parseFloat(item.price) * item.quantity)}</p>
              </div>
            ))}
            <div style={{ marginTop: "18px", textAlign: "center" }}>
              <button onClick={() => openHistory(selectedOrder)}
                style={{ padding: "10px 24px", borderRadius: "10px",
                  background: "linear-gradient(135deg,#3a6ab0,#2a5090)",
                  color: "#fff", border: "none", cursor: "pointer",
                  fontFamily: "Georgia, serif", fontSize: "12px", fontWeight: "700" }}>
                📄 View & Print Bill
              </button>
            </div>
          </div>
        </div>
      )}

      {/* History / Bill Modal */}
      {historyModal && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.55)", zIndex: 1100,
          display: "flex", alignItems: "center", justifyContent: "center", padding: "24px" }}
          onClick={e => { if (e.target === e.currentTarget) setHistoryModal(null); }}>
          <div style={{ background: "#fff", borderRadius: "18px", padding: "32px",
            maxWidth: "560px", width: "100%", boxShadow: "0 20px 60px rgba(0,0,0,.2)",
            maxHeight: "88vh", overflowY: "auto" }}>

            <div style={{ display: "flex", justifyContent: "space-between",
              alignItems: "flex-start", marginBottom: "24px" }}>
              <div>
                <h3 style={{ fontFamily: "Georgia, serif", fontSize: "17px",
                  fontWeight: "700", color: "#1a1a1a" }}>
                  Order #{historyModal.order.id} — Status Timeline
                </h3>
                <p style={{ fontFamily: "Georgia, serif", fontSize: "12px",
                  color: "#aaa", marginTop: "4px" }}>
                  {historyModal.order.user} · {inr(historyModal.order.total_price)}
                </p>
              </div>
              <button onClick={() => setHistoryModal(null)}
                style={{ background: "none", border: "none", cursor: "pointer",
                  fontSize: "20px", color: "#aaa" }}>✕</button>
            </div>

            {/* Timeline */}
            {historyLoading ? (
              <p style={{ fontFamily: "Georgia, serif", color: "#aaa", fontSize: "13px",
                textAlign: "center", padding: "32px 0" }}>Loading timeline...</p>
            ) : historyModal.entries.length === 0 ? (
              <div style={{ textAlign: "center", padding: "32px 0" }}>
                <p style={{ fontFamily: "Georgia, serif", fontSize: "13px", color: "#aaa" }}>
                  No history recorded yet.
                </p>
                <p style={{ fontFamily: "Georgia, serif", fontSize: "11px", color: "#ccc", marginTop: "6px" }}>
                  History is recorded from this point forward when you change the status.
                </p>
              </div>
            ) : (
              <div style={{ position: "relative", paddingLeft: "28px",
                borderLeft: "2px solid #f0ebe3", marginBottom: "24px" }}>
                {historyModal.entries.map((entry, i) => {
                  const cfg = STATUS_CONFIG[entry.status] || { color: "#888", bg: "#f5f5f5", icon: "•" };
                  const isLast = i === historyModal.entries.length - 1;
                  return (
                    <div key={entry.id} style={{ position: "relative", marginBottom: isLast ? 0 : "20px" }}>
                      {/* Dot */}
                      <div style={{ position: "absolute", left: "-37px", top: "3px",
                        width: "16px", height: "16px", borderRadius: "50%",
                        background: isLast ? cfg.color : "#fff",
                        border: `2px solid ${cfg.color}`,
                        display: "flex", alignItems: "center", justifyContent: "center",
                        fontSize: "8px" }}>
                        {isLast && <span style={{ color: "#fff", fontSize: "9px" }}>✓</span>}
                      </div>
                      <div style={{ background: isLast ? cfg.bg : "#faf7f2",
                        border: `1px solid ${isLast ? cfg.color : "#f0ebe3"}`,
                        borderRadius: "10px", padding: "12px 16px" }}>
                        <div style={{ display: "flex", justifyContent: "space-between",
                          alignItems: "center", marginBottom: entry.note ? "6px" : 0 }}>
                          <span style={{ fontFamily: "Georgia, serif", fontSize: "14px",
                            fontWeight: "700", color: cfg.color, textTransform: "capitalize" }}>
                            {cfg.icon} {entry.status}
                          </span>
                          <span style={{ fontFamily: "Georgia, serif", fontSize: "11px", color: "#aaa" }}>
                            {fmt(entry.timestamp)}
                          </span>
                        </div>
                        {entry.note && (
                          <p style={{ fontFamily: "Georgia, serif", fontSize: "12px",
                            color: "#888", fontStyle: "italic", marginTop: "4px" }}>
                            Note: {entry.note}
                          </p>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {/* Print / Download Bill */}
            <button
              onClick={() => printBill(historyModal.order, historyModal.entries)}
              style={{ width: "100%", padding: "13px", borderRadius: "11px",
                background: "linear-gradient(135deg,#e07b39,#c96a18)",
                color: "#fff", border: "none", cursor: "pointer",
                fontFamily: "Georgia, serif", fontSize: "13px", fontWeight: "700",
                boxShadow: "0 4px 16px rgba(201,106,24,.3)" }}>
              📄 Download / Print Bill (PDF)
            </button>
          </div>
        </div>
      )}
    </div>
  );
}